/*
 * A Donation Boost is when we suggest to a donor that they increase their donation by a few £££
 *
 * If a charity has amount-specific custom messages visible on the Donate Form, this feature is activated
 * If the donor enters an amount that is £1-4 less than the suggested amount (in the custom message list), we show the Boost button
 * The suggested amount must also be between £10 and £50
 * We only ever show 1 Boost button
 * We don't show the Boost button if the entered amount equals one of the suggested amounts
 */

import AnalyticsEvent from 'Scripts/common/analytics-event';

export default class DonationBoosts {
    constructor(opts) {
        this.ui = {
            containers: $(".js-boost-container"),
            buttons: $(".js-boost-btn"),
        }

        this.onBoostCallback = opts.onBoost;

        this.strOptions = {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }

        // Only run if there's boost buttons
        this.canRun = this.ui.buttons.length > 0;

        if(this.canRun) {
            this.bindEvents()
        }        
    }

    bindEvents() {
        this.ui.buttons.on("click", this.onClickButton.bind(this));
    }

    /*
     * Loop through the suggested donation amounts and show a button if the critera is met
     */
    checkBoosts(donationAmount) {
        if(!this.canRun) return;

        console.log("DonationBoosts.checkBoosts", donationAmount);

        let hasShownButton = false;

        this.ui.buttons.each((i, el) => {
            const button = $(el);
            const buttonValue = button.data("value");
            const diff = buttonValue - donationAmount;

            // If we already match an equal match, don't show any buttons
            if(diff == 0) {
                $(".js-boost-container").collapse("hide");
                return false;
            }

            const showButton = !hasShownButton 
                && donationAmount > 5 
                && buttonValue <= 50 
                && diff >= 1 
                && diff <= 4;

            if(showButton) {
                button.find(".js-boost-topup").html(diff.toLocaleString('en-GB', this.strOptions).replace(".00", ""));    
                hasShownButton = true;

                // Send analytics event to Heap
                AnalyticsEvent.heap('DonationBoostPrompt', {donationValue:donationAmount});
            }

            button.parent(".js-boost-container").collapse(showButton ? "show" : "hide");
        });
    }

    /*
     * Update the donation amount with the suggested amount
     */
    onClickButton(e) {
        console.log("DonationBoosts.onClickButton", $(e.currentTarget).data("value"));

        const amount = $(e.currentTarget).data("value");
        this.triggerAnimation();

        // Run callback if one exists
        this.onBoostCallback?.(amount)
    }

    /*
     * This flashes a little animation on screen
     */
    triggerAnimation() {
        const animationClass = "animate-boost";
        const animationContainer = $(".js-boost-flash");
        animationContainer.addClass(animationClass);

        setTimeout(() => {
            animationContainer.removeClass(animationClass);
        }, 1000);
    }
}